<template>
  <div class="admin">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="fichiers encart">
            <h2>Ajouter les logos des clients</h2>
            <form @submit.prevent="submit('logoClient')">
              <input id="file1" type="file" @change="addFichiers" accept="image/*,.pdf,.igs,.prt,.vcf,.step,.stp" capture required>
              <label for="file1"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
              </svg>Choisir un fichier</label>

              <select v-model="selectedClientLogo">
                <option value="">Clients</option>
                <option v-for="client in clients" :key="client.id" :value="client.cocli">{{ client.nom }}</option>
              </select>

              <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
              <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
              </svg>Envoyer le logo</button>
      
      
      
              <div v-if="successLogoClient" class="alert alert-success" role="alert">
                {{ successLogoClient }}
              </div>
              <div v-if="errorLogoClient" class="alert alert-danger" role="alert">
                {{ errorLogoClient }}
              </div>
            </form>
          </div>
          
        </div>
        <div class="col-lg-6">
          <div class="fichiers encart">
            <h2>Ajouter les logos des magasins</h2>
            <form @submit.prevent="submit('logoMagasin')">
              <input id="file2" type="file" @change="addFichiers" accept="image/*,.pdf,.igs,.prt,.vcf,.step,.stp" capture required>
              <label for="file2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
              </svg>Choisir un fichier</label>
        
              <select v-model="selectedMagLogo">
                <option value="">Magasins</option>
                <option v-for="magasin in magasins" :key="magasin.id" :value="magasin.nom_magasins">{{ magasin.nom_magasins }}</option>
              </select>

              <label for="coordonnees">Coordonnées (si il n'y en a pas laisser vide)</label>
              <textarea id="coordonnees" name="coordonnees" rows="4" v-model="selectedMagLogoCoordonnees"></textarea>
                
              <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
              <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
              </svg>Envoyer le logo</button>
      
      
      
              <div v-if="successLogoMag" class="alert alert-success" role="alert">
                {{ successLogoMag }}
              </div>
              <div v-if="errorLogoMag" class="alert alert-danger" role="alert">
                {{ errorLogoMag }}
              </div>
            </form>
          </div>
          
        </div>
      </div>

      <!--
      <div class="row">
        <div class="col-lg-6">
          <div class="fichiers encart">
            <h2>Ajouter des fichiers aux clients</h2>
            <form @submit.prevent="submit('fichierClient')">
              <input id="file3" type="file" multiple @change="addFichiers" accept="image/*,.pdf,.igs,.prt,.vcf,.step,.stp" capture required>
              <label for="file3"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
              </svg>Choisir un ou plusieurs fichier(s)</label>
  
              <select v-model="selectedClientFichier">
                <option value="">Clients</option>
                <option v-for="client in clients" :key="client.id" :value="client.nom">{{ client.nom }}</option>
              </select>

              <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
              <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
              </svg>Envoyer le/les fichier(s)</button>
      
      
      
              <div v-if="successFichierClient" class="alert alert-success" role="alert">
                {{ successFichierClient }}
              </div>
              <div v-if="errorFichierClient" class="alert alert-danger" role="alert">
                {{ errorFichierClient }}
              </div>
            </form>
          </div>
          
        </div>
        <div class="col-lg-6">
          <div class="fichiers encart">
            <h2>Ajouter des fichiers aux magasins</h2>
            <form @submit.prevent="submit('fichierMagasin')">
              <input id="file4" type="file" multiple @change="addFichiers" accept="image/*,.pdf,.igs,.prt,.vcf,.step,.stp" capture required>
              <label for="file4"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
              </svg>Choisir un ou plusieurs fichier(s)</label>
        
              <select v-model="selectedMagFichier">
                <option value="">Magasins</option>
                <option v-for="magasin in magasins" :key="magasin.id" :value="magasin.nom_magasins">{{ magasin.nom_magasins }}</option>
              </select>

              <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
              <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
              </svg>Envoyer le/les fichier(s)</button>
      
      
      
              <div v-if="successFichierMag" class="alert alert-success" role="alert">
                {{ successFichierMag }}
              </div>
              <div v-if="errorFichierMag" class="alert alert-danger" role="alert">
                {{ errorFichierMag }}
              </div>
            </form>
          </div>
          
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="fichiers encart">
            <h2>Ajouter des fichiers aux articles</h2>
            <form @submit.prevent="submit('fichierArticle')">
              <input id="file5" type="file" multiple @change="addFichiers" accept="image/*,.pdf,.igs,.prt,.vcf,.step,.stp" capture required>
              <label for="file5"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
              </svg>Choisir un ou plusieurs fichier(s)</label>
  
              <select v-model="selectedArticles">
                <option value="">Numéros d'articles</option>
                <option v-for="article in articles" :key="article.id" :value="article.coarti">{{ article.coarti }}</option>
              </select>


              <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
              <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
              </svg>Envoyer le/les fichier(s)</button>
      
      
      
              <div v-if="successFichierArticle" class="alert alert-success" role="alert">
                {{ successFichierArticle }}
              </div>
              <div v-if="errorFichierArticle" class="alert alert-danger" role="alert">
                {{ errorFichierArticle }}
              </div>
            </form>
          </div>
          
        </div>
        <div class="col-lg-6">
          <div class="fichiers encart">
            <h2>Ajouter des fichiers aux affaires</h2>
            <form @submit.prevent="submit('fichierAffaire')">
              <input id="file6" type="file" multiple @change="addFichiers" accept="image/*,.pdf,.igs,.prt,.vcf,.step,.stp" capture required>
              <label for="file6"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
              </svg>Choisir un ou plusieurs fichier(s)</label>
        
              <select v-model="selectedAffaire">
                <option value="">Numéros d'affaires</option>
                <option v-for="affaire in affaires" :key="affaire.id" :value="affaire.naf">{{ affaire.naf }}</option>
              </select>

              <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
              <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
              </svg>Envoyer le/les fichier(s)</button>
      
      
      
              <div v-if="successFichierAffaire" class="alert alert-success" role="alert">
                {{ successFichierAffaire }}
              </div>
              <div v-if="errorFichierAffaire" class="alert alert-danger" role="alert">
                {{ errorFichierAffaire }}
              </div>
            </form>
          </div>
          
        </div>
      </div>
      -->
      <div class="row">
        <div class="col-lg-6">
          <div class="fichiers encart">
            <h2>Lier espace client / magasin</h2>
            <form @submit.prevent="submitRelie()">  

              <select v-model="magasinRelie" required>
                <option value="">Magasins</option>
                <option v-for="magasin in magasins" :key="magasin.id" :value="magasin.nom_magasins">{{ magasin.nom_magasins }}</option>
              </select>

              <select v-model="clientRelie" required>
                <option value="">Clients</option>
                <option v-for="client in clients" :key="client.id" :value="client.nom">{{ client.nom }}</option>
              </select>


              <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-plus-fill" viewBox="0 0 16 16">
              <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>
              </svg>Lier le magasin au client</button>
      
      
      
              <div v-if="successRelie" class="alert alert-success" role="alert">
                {{ successRelie }}
              </div>
              <div v-if="errorRelie" class="alert alert-danger" role="alert">
                {{ errorRelie }}
              </div>
            </form>
          </div>
          
        </div>
        <div class="col-lg-6">
          <table class="table clientsMags">
            <thead>
              <tr>
                <th>Client</th>
                <th>Magasin</th>
                <th>Supprimer la liaison</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="correspondance in correspondances" :key="correspondance.id" >
                <td>{{ correspondance.client }}</td>
                <td>{{ correspondance.magasin }}</td>
                <td class="click" @click.prevent="deleteLiaison(correspondance.id)">x</td>
              </tr>
            </tbody>
          </table>
          <div v-if="successDelete" class="alert alert-success" role="alert">
            {{ successDelete }}
          </div>
          <div v-if="errorDelete" class="alert alert-danger" role="alert">
            {{ errorDelete }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="list_emails encart">
            <h2>Liste d'e-mail soldées</h2>
            <table class="table clientsMags">
              <thead>
                <tr>
                  <th>Nom</th>
                  <th>prénom</th>
                  <th>E-mail</th>
                  <th>Activer</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="utilisateur in utilisateurs" :key="utilisateur.id" >
                  <td>{{ utilisateur.nom }}</td>
                  <td>{{ utilisateur.prenom }}</td>
                  <td>{{ utilisateur.email }}</td>
                  <td>
                    <div class="form-check form-switch">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        role="switch" 
                        :id="'flexSwitchCheckDefault' + utilisateur.id" 
                        v-model="utilisateur.list_email" 
                        @change="toggleActive(utilisateur)" 
                        checked>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-lg-6">
          
        </div>
      </div>
    </div>
     <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'



export default {
  data() {
    return {
      magasins: [],
      selectedMagLogo: '',
      selectedMagLogoCoordonnees: '',
      clients: [],
      utilisateurs: [],
      selectedClientLogo: '',
      selectedMagFichier: '',
      selectedClientFichier: '',
      clientRelie: '',
      magasinRelie: '',
      affaires: [],
      selectedAffaire: '',
      articles: [],
      selectedArticles: '',
      fichiers: [],
      correspondances: [],
      successLogoClient: '',
      errorLogoClient: '',
      successLogoMag: '',
      errorLogoMag: '',
      successFichierClient: '',
      errorFichierClient: '',
      successFichierMag: '',
      errorFichierMag: '',
      successFichierArticle: '',
      errorFichierArticle: '',
      successFichierAffaire: '',
      errorFichierAffaire: '',
      successRelie: '',
      errorRelie: '',
      successDelete: '',
      errorDelete: '',
      isLoading: false,
    }
  },
  computed: {
    isListEmailActive: {
      get() {
        return this.utilisateur.list_email === "1"; // convertit "1" en true, "0" en false
      },
      set(value) {
        this.utilisateur.list_email = value ? "1" : "0"; // met à jour la valeur en fonction de la case cochée
      }
    }
  },
  mounted() {
    

    axios.get(`https://www.simef.fr/espace-client/api/getUtilisateurs.php?roles=1`)
    .then(response => {
      this.utilisateurs = response.data.utilisateurs;
    })
    .catch(error => {
      console.error(error);
      

    })
    .finally(() => {
      this.isLoading = false; // Hide loader
    });


    axios.get('https://www.simef.fr/espace-client/api/getMagasins.php')
    .then(response => {
      this.magasins = response.data;
    })
    .catch(error => {
      console.error(error);
      
    });


    axios.get('https://www.simef.fr/espace-client/api/getClientsAll.php')
    .then(response => {
      this.clients = response.data;
    })
    .catch(error => {
      console.error(error);
      
    });

    axios.get('https://www.simef.fr/espace-client/api/getAffaire.php')
    .then(response => {
      this.affaires = response.data;
    })
    .catch(error => {
      console.error(error);
      
    });

    axios.get('https://www.simef.fr/espace-client/api/getAllArticles.php')
    .then(response => {
      this.articles = response.data;
    })
    .catch(error => {
      console.error(error);
      
    });

   this.getClient();

  }, 
 
  methods: {
    submit(type) {
      // Create a new FormData object
      const formData = new FormData();

      // Ajouter les fichiers au formulaire
      for (let i = 0; i < this.fichiers.length; i++) {
          formData.append('fichiers[]', this.fichiers[i]);
      }
      // Add the user and chantier information to the form data
      if (type === 'logoClient') { 
        formData.append('logoClient', this.selectedClientLogo);
      } else if (type === 'logoMagasin') {
        formData.append('logoMagasin', this.selectedMagLogo);
        if(this.selectedMagLogoCoordonnees != '') {
          formData.append('logoMagasinCoordonnees', this.selectedMagLogoCoordonnees)
        }
      } else if (type === 'fichierClient') {
        formData.append('fichierClient', this.selectedClientFichier);
      } else if (type === 'fichierMagasin') {
        formData.append('fichierMagasin', this.selectedMagFichier);
      } else if (type === 'fichierArticle') {
        formData.append('fichierArticle', this.selectedArticles);
      } else if (type === 'fichierAffaire') {
        formData.append('fichierAffaire', this.selectedAffaire);
      }
     
      this.isLoading = true; // Show loader
      // Make the API request
      axios.post('https://www.simef.fr/espace-client/api/ajoutFichiersAll.php', formData)
      .then(response => {
          // Handle the response from the server
          this.successLogoClient = response.data.successLogoClient;
          this.errorLogoClient = response.data.errorLogoClient;
          this.successLogoMag = response.data.successLogoMag;
          this.errorLogoMag = response.data.errorLogoMag;

          this.successFichierClient = response.data.successFichierClient;
          this.errorFichierClient = response.data.errorFichierClient;
          this.successFichierMag = response.data.successFichierMag;
          this.errorFichierMag = response.data.errorFichierMag;
      
          this.successFichierArticle = response.data.successFichierArticle;
          this.errorFichierArticle = response.data.errorFichierArticle;
          this.successFichierAffaire = response.data.successFichierAffaire;
          this.errorFichierAffaire = response.data.errorFichierAffaire;

          this.fichiers = [];
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      })
      .finally(() => {
        this.isLoading = false; // Hide loader
      });
    },
    submitRelie() {
      axios.post('https://www.simef.fr/espace-client/api/relierMagasinsClients.php', {
        clientRelie: this.clientRelie,
        magasinRelie: this.magasinRelie
      })
      .then(response => {
          // Handle the response from the server
          this.successRelie = response.data.successRelie;
          this.errorRelie = response.data.errorRelie;
          this.getClient();
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    },
    addFichiers(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
          this.fichiers.push(files[i]);
      }
    },
    getClient() {
      axios.get('https://www.simef.fr/espace-client/api/getMagasinsClients.php')
      .then(response => {
        this.correspondances = response.data;
      })
      .catch(error => {
        console.error(error);
        
      });
    },
    deleteLiaison(id) {
      const confirmation = window.confirm('Êtes-vous sûr de vouloir supprimer cette liaison ?');

      if (confirmation) {
        axios.post('https://www.simef.fr/espace-client/api/deleteLiaison.php', {
          idClientMagasin: id,
        })
        .then(response => {
          this.successDelete = response.data.successDelete;
          this.errorDelete = response.data.errorDelete;
          this.getClient();
        })
        .catch(error => {
          console.error(error);
        });
      }
    },
    toggleActive(utilisateur) {
    // Convertir list_email en entier (1 pour activé, 0 pour désactivé)
    console.log(utilisateur.list_email);
    const status = utilisateur.list_email === true ? 1 : 0;

    // Vérifier que l'utilisateur a un ID
    if (utilisateur.id) {
      axios.post('https://www.simef.fr/espace-client/api/updateListEmail.php', {
        id: utilisateur.id, // ID de l'utilisateur
        list_email: status  // Nouveau statut
      })
      .then(response => {
        // Gérer la réponse
        if (response.data.success) {
          console.log('Statut mis à jour avec succès');
        } else {
          console.error('Erreur lors de la mise à jour du statut', response.data);
        }
      })
      .catch(error => {
        console.error('Erreur lors de la requête :', error);
      });
    } else {
      console.error('Utilisateur invalide', utilisateur);
    }
  }


   
  },

  
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .admin {
    padding-bottom: 255px;
  }
  textarea {
    width: 100%;
}
  .multiselect {
    select, input {
      padding: 0px!important;
    } 
  }
  .click {
    cursor: pointer;
    text-align: right;
  }

  .clientsMags {
    text-align: left;
  }


</style>
